import React, { useContext, useState, useEffect } from "react";

// Styles
import "./style.scss";

// Fade in
import FadeIn from "react-fade-in";

// components
import AddClassFormHeader from "./AddClassFormHeader";
import AddClassFormClassName from "./AddClassFormClassName";
import AddClassFormClassDescription from "./AddClassFormClassDescription";
import AddClassFormProperties from "./AddClassFormProperties";
import AddClassFormSubmitForm from "./AddClassFormSubmitForm";
import AddNewPropertyModal from "./AddNewPropertyModal";
import AddClassFormAdvancedSettingsButton from "./AddClassFormAdvancedSettingsButton";
import AddClassFormAddNewPropertyButton from "./AddClassFormAddNewPropertyButton";
import AddNewClassAdvancedSettingsModal from "./AddNewClassAdvancedSettingsModal";

// Global state
import { StateContext } from "../../AppStateContext";

const AddClassForm = () => {
  const state = useContext(StateContext);
  const [isAddPropertyModalOpen, setIsAddPropertyModalOpen] = useState(false);
  const [
    isClassAdvancedSettingsModalOpen,
    setIsClassAdvancedSettingsModalOpen,
  ] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <FadeIn transitionDuration={1000}>
      <div
        className={
          state.theme === "dark"
            ? "__schemaAddClassPage __schemaAddClassPageDark"
            : "__schemaAddClassPage __schemaAddClassPageLight"
        }
      >
        <form className="__addClassForm" autoComplete="off" id="addClassForm">
          <AddClassFormHeader state={state} />
          <AddClassFormClassName />
          <AddClassFormClassDescription />
          <AddClassFormProperties
            setIsAddPropertyModalOpen={setIsAddPropertyModalOpen}
          />
          <AddClassFormAddNewPropertyButton
            setIsAddPropertyModalOpen={setIsAddPropertyModalOpen}
          />
          <AddClassFormAdvancedSettingsButton
            setIsClassAdvancedSettingsModalOpen={
              setIsClassAdvancedSettingsModalOpen
            }
          />
          <AddClassFormSubmitForm />
          <AddNewPropertyModal
            isAddPropertyModalOpen={isAddPropertyModalOpen}
            setIsAddPropertyModalOpen={setIsAddPropertyModalOpen}
          />
          <AddNewClassAdvancedSettingsModal
            isClassAdvancedSettingsModalOpen={isClassAdvancedSettingsModalOpen}
            setIsClassAdvancedSettingsModalOpen={
              setIsClassAdvancedSettingsModalOpen
            }
          />
        </form>
      </div>
    </FadeIn>
  );
};

export default AddClassForm;
